import AcademicYearService from '@/services/academicYear.service';
import SubjectService from '@/services/subject.service';
import Axios from '@/Axios';

const state = () => ({
    academicYears: [],
    grades: [],
    subjects: [],
    loadingAcademicYears: false,
    loadingGrades: false,
    loadingSubjects: false,
});

const getters = {
    allAcademicYears: (state) => state.academicYears,
    allGrades: (state) => state.grades,
    allSubjects: (state) => state.subjects,
    isLoading: (state) => state.loadingAcademicYears || state.loadingGrades || state.loadingSubjects,
};

const actions = {
    async fetchAcademicYears({ commit, state }) {
        if (state.academicYears.length > 0) return;
        
        commit('SET_LOADING_YEARS', true);
        try {
            // Using service for consistency with codebase
            const data = await AcademicYearService.getAcademicYears({ include: 'grade' });
            commit('SET_ACADEMIC_YEARS', data);
        } catch (error) {
            console.error('Error fetching academic years:', error);
        } finally {
            commit('SET_LOADING_YEARS', false);
        }
    },

    async fetchGrades({ commit, state }) {
        if (state.grades.length > 0) return;

        commit('SET_LOADING_GRADES', true);
        try {
            // No GradeService found, using Axios directly
            const response = await Axios.get('/grades');
            commit('SET_GRADES', response.data.data);
        } catch (error) {
            console.error('Error fetching grades:', error);
        } finally {
            commit('SET_LOADING_GRADES', false);
        }
    },

    async fetchSubjects({ commit, state }, forceRefresh = false) {
        if (state.subjects.length > 0 && !forceRefresh) return;

        commit('SET_LOADING_SUBJECTS', true);
        try {
            const data = await SubjectService.getSubjects();
            commit('SET_SUBJECTS', data);
        } catch (error) {
            console.error('Error fetching subjects:', error);
        } finally {
            commit('SET_LOADING_SUBJECTS', false);
        }
    }
};

const mutations = {
    SET_ACADEMIC_YEARS: (state, data) => (state.academicYears = data),
    SET_GRADES: (state, data) => (state.grades = data),
    SET_SUBJECTS: (state, data) => (state.subjects = data),
    SET_LOADING_YEARS: (state, val) => (state.loadingAcademicYears = val),
    SET_LOADING_GRADES: (state, val) => (state.loadingGrades = val),
    SET_LOADING_SUBJECTS: (state, val) => (state.loadingSubjects = val),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
